import React, {forwardRef, useImperativeHandle, useRef, useState, useEffect} from "react";
import styled from "styled-components";
import Sizes from "../Assets/Sizes";
import {isFunction} from "@tomeravni/easybizy-js-common/common";

const InputPartWrapper = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

const FullWidthInput = styled.input`
    text-align: center;
    width: 100%;
    border: none;
    border-bottom: 2px solid ${p => p.theme.colors.primaryText};
    color: ${p => p.theme.colors.primaryText};
    background-color: transparent;
    font-size: ${p => p.inputFont === 'large' ? Sizes.lTextSize : Sizes.xlTextSize};
    box-shadow: none;
    border-radius: 0;
    direction: ltr;
    flex-grow: 1;
`;

const TypeNumberMessage = styled.div`
    width: 100%;
    color: ${p => p.theme.colors.primaryText};
    margin: ${Sizes.mediumPadding};
    text-align: center;
`;

const InputPart = forwardRef(function InputPart(props, ref) {
    const {
        inputFont,
        inputType = 'text',
        inProgress,
        pattern,
        disabled,
        autoComplete,
        label,
        onSubmit,
        isFocused,
        validateAdaptValue,
        validityStatusChange,
        value: initialValue = '',
        onChange,
    } = props;

    const validateAdapt = validateAdaptValue || ((val) => ({isValid: true, adaptedValue: val}));

    const inputRef = useRef(null);
    const [value, setValue] = useState(initialValue);
    const [isValid, setIsValid] = useState(validateAdapt(initialValue).isValid);

    function focus() {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }

    useImperativeHandle(ref, () => ({
        focus: focus,
        getIsValid: function () {
            return isValid;
        },
        getValue: function () {
            return value;
        }
    }));

    const isValidStateChange = validityStatusChange || (() => {
    });



    // isValidStateChange is recreated each render; intent is to fire when isValid changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(function () {
        isValidStateChange(isValid);
    }, [isValid]);

    // focus on mount if isFocused is true; isFocused changes are handled by the next effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (isFocused) {
            setTimeout(() => {
                if (isFocused) {
                    focus();
                }
            }, 500);
        }
    }, []);

    // validateAdapt is recreated each render; only re-run on isFocused change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(function () {
        if (isFocused) {
            const result = validateAdapt(value);
            setValue(result.adaptedValue);
            setIsValid(result.isValid);

            setTimeout(function () {
                focus();
            }, 500);
        }
    }, [isFocused]);

    function onValueChange(evt) {
        const {isValid, adaptedValue} = validateAdapt(evt.target.value);
        setValue(adaptedValue)
        setIsValid(isValid);
        if (isFunction(onChange)) {
            onChange({target: {value: adaptedValue}});
        }
    }

    function onKeyDown(evt) {
        if (evt.key === 'Enter' && isValid && typeof onSubmit === 'function') {
            onSubmit(value);
        }
    }

    return (
        <InputPartWrapper>
            <FullWidthInput
                onKeyDown={onKeyDown}
                disabled={inProgress || disabled}
                innerRef={inputRef}
                pattern={pattern}
                autoComplete={autoComplete || 'off'}
                inputFont={inputFont}
                value={value}
                onChange={onValueChange}
                type={inputType}
                inputMode={inputType}
                id={'text-phone-' + Math.floor(Math.random() * 1000000)}
            />
            <TypeNumberMessage>{label}</TypeNumberMessage>
        </InputPartWrapper>
    );
});

export default InputPart;
